module.exports = __webpack_public_path__ + "static/media/logo-rover.f0760006.svg";